import { a as __assign } from '../../tslib.es6-21effb23.js';
import { c as classNames } from '../../index-29eed6c4.js';
import * as React from 'react';
import { s as styles } from '../../DataTable.module-41fa1c12.js';
import { T as TableCell } from '../../index-264b45c1.js';
import { TableRow } from './TableRow.js';
import '../../ChevronRightIcon-d61e7ef9.js';
import '../../countries-66cada71.js';
import '../../index-90b64be0.js';
import '../../useId-b2f228e9.js';
import '../../CheckIcon-dae9b9aa.js';
import '../../skeleton.module-4f527a2f.js';
import '../../RowContext-cd4416e5.js';
import './Tooltip.js';
import '../../index-d8cd4037.js';
import 'react-spring';
import 'react/jsx-runtime';
import 'react-dom';
import '../../useOrchard-7b9a6b37.js';
import './IconButton.js';
import './TextLink.js';
import './Typography.js';
import '../../ResizeObserver-c9aca664.js';
import '../../CircleAlertIcon-4b674f5b.js';
import '../../CloseIcon-a96790fc.js';
import '../../InfoIcon-b656f0ef.js';
import '../../ThemeProvider-030aad7d.js';

function createRow(rowData, columnDefs) {
    return columnDefs.map(function (def, index) {
        var Component = def.component;
        var item = rowData[index];
        return React.createElement(Component, __assign({ key: index }, item));
    });
}
function TableBody(props) {
    var rowsInfo = props.rowsInfo, columnDefs = props.columnDefs;
    var getCellClassNames = React.useCallback(function (column) {
        var _a;
        return classNames((_a = {},
            _a[styles.alignCenter] = columnDefs[column].align === "center",
            _a[styles.alignRight] = columnDefs[column].align === "right",
            _a));
    }, [columnDefs]);
    return (React.createElement("tbody", null, rowsInfo.map(function (row, rowIndex) {
        var cells = createRow(row.data, columnDefs);
        return (React.createElement(TableRow, { key: rowIndex, onClick: row.onClick, rowClassName: row.rowClassName, onMouseEnter: row.onMouseEnter, onMouseLeave: row.onMouseLeave }, cells.map(function (item, columnIndex) { return (React.createElement(TableCell, { key: item.key, className: getCellClassNames(columnIndex) }, item)); })));
    })));
}

export { TableBody };
